import { CountryCode } from '@src/common/auth';
import { normalizeForeignPostalCode } from '@src/domains/customers/core/normalizeForeignPostalCode';
import { normalizeZipCode } from '@src/domains/customers/core/normalizeZipCode';

export const ZIP_CODE_LENGTH = 8;

/** Zip code is optional (absence is valid). The length rule applies only to Brazil. */
export function isValidZipCode(zipCode: string | null | undefined, countryCode: string | null | undefined): boolean {
  if (!zipCode?.trim()) return true;

  if (countryCode === CountryCode.BRAZIL) {
    const normalized = normalizeZipCode(zipCode);
    return normalized !== null && normalized.length >= ZIP_CODE_LENGTH;
  }

  return normalizeForeignPostalCode(zipCode) !== null;
}
